import './Header.module.scss';

import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectHistoricalUsageInfo } from '@app/redux//usageHistory';
import { selectConfig } from '@app/redux/config';
import { selectPlanCharacteristics } from '@app/redux/plan';

import { UsageToggle } from '../../components/UsageToggle/UsageToggle';
import { useStoreContext } from '../../context';

import LoadingStyles from '../../components/Loading/Loading.module.scss';
import Styles from './Header.module.scss';

export const Header = (): JSX.Element | null => {
  const { t } = useTranslation('UsageHistory');
  const { selectedBillCycle, showMonthly } = useStoreContext();

  const { loading, billCycles } = useSelector(selectHistoricalUsageInfo);
  const {
    characteristics: { hasUnlimitedUsageMeter },
  } = useSelector(selectPlanCharacteristics);

  const averageUsage = billCycles[selectedBillCycle]?.averageUsage;
  const onlyShowUsageToggle = !hasUnlimitedUsageMeter && showMonthly;

  if (onlyShowUsageToggle) {
    return (
      <div className={Styles.NavSection} data-cy="chart-header">
        <UsageToggle initialMode={'monthly'} />
      </div>
    );
  }

  return (
    <div className={Styles.NavSection} data-cy="chart-header">
      {!hasUnlimitedUsageMeter && (
        <div style={{ flexGrow: 1 }}>
          <UsageToggle initialMode={'daily'} />
        </div>
      )}
      {loading ? (
        <div className={LoadingStyles.averageUsageLoading} data-cy="loading-average-usage" />
      ) : (
        <div className={Styles.AverageUsageWrapper} data-cy="average-usage">
          <Txt variant="labelMedium" color="subtle">
            {t('averageUsage', { averageUsage })}
          </Txt>
        </div>
      )}
    </div>
  );
};
